import { render, staticRenderFns } from "./page-html.vue?vue&type=template&id=5056ce7c&scoped=true"
import script from "./page-html.vue?vue&type=script&lang=js"
export * from "./page-html.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056ce7c",
  null
  
)

export default component.exports